export default {
  confirmDestroy: '削除してよろしいでしょうか？',
  errorAndTry: 'エラーが発生しました。時間をおいて再度お試しください',
}
